<template>
  <div class="feed-media">
    <video
      ref="videoPlayer"
      class="video-js vjs-big-play-centered"
      preload="auto"
      controls="controls"
    >
      <source :src="feed.uriKey[0]" type="video/mp4" />
    </video>
  </div>
</template>
<script>
import "video.js/dist/video-js.css";
import videojs from "video.js";
import { videoChinese } from "../../../utils/common";
export default {
  name: "video-element",
  props: {
    feed: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      player: null,
      options: {
        language: "zh-CN",
      },
    };
  },
  beforeMount() {
    videojs.addLanguage("zh-CN", videoChinese);
  },
  mounted() {
    this.player = videojs(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {}
    );
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
<style scoped>
.feed-media {
  width: 650px;
  height: 380px;
  margin: 5px 0;
}

.feed-media .video-js {
  width: 100%;
  height: 100%;
}
</style>